import {Dialog, FlatButton} from 'material-ui';
import React, {PropTypes} from 'react';

export default function ConfirmModal({show, title, message, messageStyle, confirmButtonStyle, onCancel, onConfirm, processing}) {

  const actions = [
    <FlatButton label="Cancel" primary onTouchTap={onCancel} />,
    <FlatButton label={processing ? 'Processing...' : 'Confirm'} onTouchTap={onConfirm} />
  ];

  return (
    <Dialog
      title={title || 'Confirm'}
      actions={actions}
      modal
      open={show}>
      {message}
    </Dialog>
  );
}

ConfirmModal.propTypes = {
  confirmButtonStyle: PropTypes.oneOf(['primary', 'success', 'info', 'warning', 'danger']),
  message: PropTypes.element.isRequired,
  messageStyle: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  processing: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/features/shared/components/ConfirmModal.js